<template>
	<div>
		<core-layout-content full>
			<core-layout-headline-and-actions class="bb1 bc7 xs-bottom">
				<!-- Headline  -->
				<template slot="headline">
					<div>
						<!-- Back button -->
						<j-button
							size="small"
							type="secondary"
							@click="$router.push({ name: 'Endorsements' })"
							class="mb4"
						>
							<crm-icon name="back" size="normal" color="c5" class="mr1" />
						</j-button>
						{{ $t("endorsement") }}
					</div>
				</template>

				<!-- Tabs -->
				<!-- TODO: -->
				<!-- displaying only for aeg and aeg_uat, other tenants don't have endorsement transactions yet -->
				<!-- If we wanted to add it for other tenants, most likely create a default that would be displayed for other tenants -->
				<div slot="actions" class="xs-12" v-if="hasEndorsementTransactions">
					<j-tabs
						:selectedTab="selectedTab"
						:tabs="[
							{
								name: $t('details'),
								value: 'detail'
							},
							{
								name: $t('endorsement_transactions'),
								value: 'transactions'
							}
						]"
						@click="selectedTab = $event"
					/>
				</div>
			</core-layout-headline-and-actions>
		</core-layout-content>

		<!-- Endorsement Detail -->
		<div v-if="selectedTab === 'detail'">
			<endorsement-details :endorsementId="endorsementId" :id="id" />
		</div>

		<!-- Endorsement Transactions -->
		<div v-else-if="selectedTab === 'transactions'">
			<aeg-endorsement-transactions-list />
		</div>
	</div>
</template>

<script>
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions"
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent"
import JButton from "@/components/JButton/"
import CrmIcon from "@/components/CrmIcon/"
import EndorsementDetails from "../components/EndorsementDetails"
import JTabs from "@/components/JTabs"

// CMS
import AegEndorsementTransactionsList from "../components/mockedCms/AegEndorsementTransactionsList"

export default {
	components: {
		CoreLayoutHeadlineAndActions,
		CoreLayoutContent,
		JButton,
		CrmIcon,
		EndorsementDetails,
		JTabs,
		AegEndorsementTransactionsList
	},

	props: {
		// From router
		id: String, // policyId
		endorsementId: String
	},

	data() {
		return {
			selectedTab: "detail"
		}
	},

	computed: {
		hasEndorsementTransactions() {
			if (
				this.$store.state.tenantId === "aeg" ||
				this.$store.state.tenantId === "aeg_uat"
			)
				return true

			return false
		}
	}
}
</script>
